export default "/_next/static/images/a19302c836b500d61ddbbc81500f5d79.png";